import { useAuth } from '../hooks/useAuth';
import { CentificLogo } from './CentificLogo';

export function HeroBanner() {
  const { login } = useAuth();

  return (
    <div className="flex items-center justify-center px-6 py-8 relative z-10 w-full">
      <div className="max-w-6xl w-full mx-auto px-8 sm:px-14 py-12 bg-white rounded-3xl shadow-2xl backdrop-blur-sm animate-fade-in relative z-20">
        <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold text-gray-900 mb-8 leading-tight tracking-tight text-center">
          Employee Connect Forum
        </h1>
        
        <p className="text-xl text-gray-600 mb-12 leading-relaxed max-w-2xl mx-auto text-center">
          Gather valuable insights from your employees with our seamless connect collection platform.
        </p>
        
        <div className="flex justify-center">
          <button 
              onClick={login} 
              className="inline-flex items-center gap-0 px-10 py-5 bg-black hover:bg-gray-800 text-white text-lg font-semibold rounded-xl transition-all duration-300 hover:scale-105 hover:shadow-2xl group focus:outline-none focus:ring-4 focus:ring-gray-300"
              aria-label="Sign in with Centific"
            >
              <span>Sign in with</span>
              <CentificLogo className="h-11" />
            </button>
        </div>
      </div>
    </div>
  );
}